export type IntegrationSource =
  | "gmail"
  | "fireflies"
  | "clickup"
  | "telegram"
  | "gohighlevel"
  | "zoom"
  | "ringcentral"
  | "google_calendar";

export type IntegrationContentMode = 'raw' | 'agent';

export type IntegrationIndexItem = {
  source: IntegrationSource;
  externalId: string;
  title: string;
  content: string;
  metadata?: Record<string, unknown>;
  remoteUpdatedAt?: string | null;
};

export type IntegrationIndexResult = {
  indexed: string[];
  failed: Array<{ externalId: string; error: string }>;
};

export type IntegrationSearchResult = {
  source: IntegrationSource;
  externalId: string;
  title: string;
  chunkText: string;
  chunkIndex: number;
  similarity: number;
  metadata?: Record<string, unknown>;
  contentMode?: IntegrationContentMode;
};

export type IntegrationIndexRecord = {
  source: IntegrationSource;
  external_id: string;
  title: string | null;
  indexed_at: string;
  remote_updated_at: string | null;
  chunk_count: number;
  metadata: Record<string, unknown> | null;
};

export function integrationTargetId(source: IntegrationSource, externalId: string): string {
  return `${source}:${externalId}`;
}

export function formatIntegrationDisplayTitle(
  source: IntegrationSource,
  title: string
): string {
  const prefix =
    source === "gmail"
      ? "Gmail"
      : source === "fireflies"
        ? "Fireflies"
        : source === "telegram"
          ? "Telegram"
          : source === "gohighlevel"
            ? "GoHighLevel"
            : source === "zoom"
              ? "Zoom"
              : source === "ringcentral"
                ? "RingCentral"
                : source === "google_calendar"
                  ? "Google Calendar"
                  : "ClickUp";
  return `${prefix}: ${title}`;
}
